import { Experiment } from '@amplitude/experiment-js-client'

/**
 * Client for reading feature flag and experiment variants from Amplitude
 *
 * Usage:
 *  const { client, isLoading, error } = useExperimentsContext()
 *  client.variant('key')
 */
export const getClient = () => {
  // Check sessionStorage which is required for the Amplitude SDK
  if (typeof window !== 'undefined') {
    return Experiment.initialize(process.env.NEXT_PUBLIC_AMPLITUDE_DEPLOYMENT_KEY ?? '', { retryFetchOnFailure: false })
  }

  return undefined
}
